module.exports = __webpack_public_path__ + "static/media/29DUNON16.9e21d9a9.jpg";